module.exports = {
	"pagination": {
		"DescribeClusterParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ParameterGroups"
		},
		"DescribeClusterParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeClusterSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterSecurityGroups"
		},
		"DescribeClusterSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Snapshots"
		},
		"DescribeClusterSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterSubnetGroups"
		},
		"DescribeClusterVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterVersions"
		},
		"DescribeClusters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Clusters"
		},
		"DescribeDefaultClusterParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "DefaultClusterParameters.Marker",
			"result_key": "DefaultClusterParameters.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeHsmClientCertificates": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "HsmClientCertificates"
		},
		"DescribeHsmConfigurations": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "HsmConfigurations"
		},
		"DescribeOrderableClusterOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableClusterOptions"
		},
		"DescribeReservedNodeOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedNodeOfferings"
		},
		"DescribeReservedNodes": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedNodes"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/redshift-2012-12-01.paginators.json
// module id = 1389
// module chunks = 0